import React from 'react'
import BackButton from '../components/BackButton'
import { FaCheckCircle, FaTimesCircle, FaCoins } from 'react-icons/fa'

const CancellationPolicy = () => {
  const policyItems = [
    {
      timing: 'Immediate',
      timeValue: '100%',
      title: 'Full Refund — Service Not Started',
      description: 'A full refund will be issued when service work has not commenced and no third-party fees have been incurred.',
      status: 'Eligible'
    },
    {
      timing: 'Prior to Processing',
      timeValue: 'Up to 24 hours',
      title: 'Conditional Refund',
      description: 'Refunds may be granted if the request is received before any processing or verification steps have begun.',
      status: 'Eligible'
    },
    {
      timing: 'In Progress',
      timeValue: 'After 24 hours',
      title: 'Refund Not Permitted',
      description: 'Once processing or document submission has commenced, refunds are generally not permitted except under exceptional circumstances.',
      status: 'Not Eligible'
    },
    {
      timing: 'Government & Third-Party Fees',
      timeValue: 'Non-refundable',
      title: 'Fees Excluded',
      description: 'Any government or third-party fees paid on your behalf are non-refundable where required by the third party.',
      status: 'Final'
    }
  ];

  return (
    <div className="min-h-[calc(100vh-70px)] bg-gray-50 dark:bg-gray-900 px-4 py-6 sm:px-8 sm:py-8 flex justify-center">
      <div className="w-full mx-auto bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 px-4 py-6 sm:px-8 sm:py-8">
        <div className="mb-6">
          <BackButton />
        </div>

        <header className="mb-4 sm:mb-6 text-center">
          <h1 className="text-lg sm:text-2xl font-semibold text-gray-900 dark:text-white">Cancellation and Refund Policy</h1>
          <p className="mt-2 text-xs sm:text-sm text-gray-600 dark:text-gray-400">Effective date: 01 January 2026. Please review these terms carefully.</p>
          <hr className="mt-4 border-t border-gray-200 dark:border-gray-700" />
        </header>

        <section className="mb-6">
          <p className="text-sm text-gray-700 dark:text-gray-300">This document outlines the procedures and conditions under which cancellations and refunds are handled by the administration. Refunds are processed in accordance with the terms set forth below and applicable regulations.</p>
        </section>

        <section className="space-y-4">
          {policyItems.map((item, index) => (
            <div key={index} className="flex flex-col sm:flex-row items-start gap-3 sm:gap-4 p-3 sm:p-4 bg-gray-50 dark:bg-gray-900 border border-gray-100 dark:border-gray-800 rounded">
              <div className="flex-shrink-0 w-full sm:w-28 text-sm text-gray-600 dark:text-gray-400 text-center sm:text-left">
                <div className="font-medium text-gray-800 dark:text-gray-100">{item.timing}</div>
                <div className="text-xs mt-1">{item.timeValue}</div>
              </div>

              <div className="flex-1">
                <h3 className="text-sm font-semibold text-gray-900 dark:text-white">{item.title}</h3>
                <p className="mt-1 text-sm text-gray-600 dark:text-gray-300">{item.description}</p>
              </div>

              <div className="mt-3 sm:ml-4 sm:mt-0 flex-shrink-0 self-start sm:self-center">
                <span className={`inline-flex items-center px-2.5 py-0.5 sm:px-3 sm:py-1 rounded-full text-xs font-medium ${
                  item.status === 'Eligible' ? 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900 dark:text-emerald-200' :
                  item.status === 'Not Eligible' ? 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200' :
                  'bg-slate-100 text-slate-800 dark:bg-slate-800 dark:text-slate-200'
                }`}>
                  {item.status === 'Eligible' ? <FaCheckCircle className="mr-2" /> : item.status === 'Not Eligible' ? <FaTimesCircle className="mr-2" /> : <FaCoins className="mr-2" />}
                  {item.status}
                </span>
              </div>
            </div>
          ))}
        </section>

        <section className="mt-6 p-4 rounded bg-white dark:bg-gray-800 border border-gray-100 dark:border-gray-700">
          <h4 className="text-sm font-semibold text-gray-900 dark:text-white mb-2">Important Notes</h4>
          <ul className="list-disc list-inside text-sm text-gray-700 dark:text-gray-300 space-y-2">
            <li>All refund requests must be submitted in writing within seven (7) days from the date of service initiation.</li>
            <li>Refunds exclude any non-refundable government or third-party fees.</li>
            <li>Approved refunds are typically processed within 5–10 business days.</li>
            <li>Refund determinations are made in accordance with company policy and applicable law; exceptions may be considered at the administration's discretion.</li>
          </ul>
        </section>

        <footer className="mt-6 text-sm text-gray-600 dark:text-gray-400">
          <p>If you require assistance or an exception, please contact our support team at <a href="mailto:support@example.com" className="text-indigo-600 dark:text-indigo-400">contact@rtobharat.com</a>.</p>
        </footer>
      </div>
    </div>
  )
}

export default CancellationPolicy